import { useContext } from 'react';
import { LocaleContext } from '../../contexts';

export function useLocale() {
  const { lang } = useContext(LocaleContext);
  return lang;
}
